// Define a mapping between series slugs and tab names on the sheet.
// The values here cannot be translated because they refer to sheet tab identifiers.
const series = new Map();

series.set('allTypes', 'Total National Health Expenditures');
series.set('dental', 'Total Dental Services Expenditures');
series.set('durableMedicalEquipment', 'Total Durable Medical Equipment Expenditures');
series.set('federalAdministration', 'Federal Administration Expenditures');
series.set('healthConsumption', 'Health Consumption Expenditures');
series.set('homeHealth', 'Total Home Health Care Expenditures');
series.set('hospitals', 'Total Hospital Expenditures');
series.set('netCostOfHealthInsurance', 'Net Cost of Health Insurance Expenditures');
series.set('nonDurableMedicalProducts', 'Total Non-Durable Medical Products Expenditures');
series.set('nursingCare', 'Total Nursing Care Facilities and Continuing Care Retirement Communities');
series.set('otherHealthAndResidential', 'Total Other Health, Residential, and Personal Care Expenditures');
series.set('otherProfessionalServices', 'Total Other Professional Services Expenditures');
series.set('personalHealthCare', 'Personal Health Care');
series.set('physiciansAndClinics', 'Total Physician and Clinical Expenditures');
series.set('prescriptionDrug', 'Total Prescription Drug Expenditures');
series.set('stateAndLocalAdministration', 'State and Local Administration Expenditures');
series.set('totalAdministration', 'Total Administration and Total Net Cost of Health Insurance Expenditures');

export default series;
